import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import Button from "../../../../../components/buttons/buttons";
import DeleteWebhookModal from "../../../../../components/modals/admin/deleteWebhookModal";

export default function SingleWebHook() {
  const location = useLocation();
  const navigate = useNavigate();
  const webhook = location.state?.webhook;

  const [isOpen, setIsOpen] = useState(false);

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  if (!webhook) {
    return (
      <div className="text-center py-10">
        <p className="text-lg font-medium">Webhook not found</p>
        <Button.Primary
          title={"Go Back"}
          className={"mt-4 rounded-md px-4"}
          onClick={() => navigate(-1)}
        />
      </div>
    );
  }

  return (
    <div data-test="singleWebhook-page">
      <div className="border border-[#E4E4F3] dark:border-none bg-white dark:bg-[#121212] rounded-md py-5 px-8 mt-6">
        <div className="border-b border-[#E4E4F3] py-3 flex justify-between items-center">
          <h3 className="text-lg font-medium">Webhook Details</h3>
          <Button.Primary title={" Delete Web Hook"} onClick={openModal} />
        </div>

        <div className="grid grid-cols-2 gap-6 sm:grid-cols-3 sm:gap-8 mt-6">
          <div>
            <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-4">
              Label
            </label>
            <p className="text-[#151515] dark:text-white text-sm mt-3 font-bold">
              {webhook?.label}
            </p>
          </div>
          <div>
            <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
              URL
            </label>
            <p className="text-[#151515] dark:text-white text-sm mt-3 font-bold break-all">
              {webhook?.url}
            </p>
          </div>
          <div>
            <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
              Created
            </label>
            <p className="text-[#151515] dark:text-white text-sm mt-3 font-bold">
              {moment(webhook?.created_at).format("MMM DD YYYY")}
            </p>
          </div>
          <div>
            <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
              Signature
            </label>
            <p className="text-[#151515] dark:text-white text-sm mt-3 font-bold break-all">
              {webhook?.signature}
            </p>
          </div>
          <div>
            <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
              Events Allowed
            </label>
            <div className="mt-3 flex flex-wrap gap-2">
              {webhook?.events_allowed?.length > 0 ? (
                webhook.events_allowed.map((event, index) => (
                  <span
                    key={index}
                    className="inline-block bg-gray-100 dark:bg-gray-800 text-sm text-[#151515] dark:text-white px-2 py-1 rounded"
                  >
                    {event}
                  </span>
                ))
              ) : (
                <p className="text-sm text-gray-500">No events configured</p>
              )}
            </div>
          </div>
        </div>
      </div>

      <DeleteWebhookModal
        show={isOpen}
        onClose={closeModal}
        id={webhook?.id}
        webhook={webhook}
      />
    </div>
  );
}
